import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { StyledButtonBack } from './styles';
import Utils from '../../../utils';
import RoutesUtils from '../../../utils/routes';

interface ButtonBackProps {
	parentId: number;
}

const ButtonBack = ({ parentId }: ButtonBackProps) => (
	<StyledButtonBack
		type="button"
		onClick={() => RoutesUtils.redirectToParentDir(parentId)}
	>
		{Utils.getSvgIcon('iconset_back')}
		<Translate value="messages.back" />
	</StyledButtonBack>
);

export default ButtonBack;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonBack/index.tsx